import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isOpen: false,
	position: {
		x: 0,
		y: 0
	},
	actions: [],
};

const contextMenuSlice = createSlice({
	name: 'contextMenu',
	initialState,
	reducers: {
		
		openContextMenu(state, action) {

			state.isOpen = true;
			state.actions = action.payload.actions;
			state.position.x = action.payload.x;
			state.position.y = action.payload.y;

		},

		closeContextMenu(state) {

			state.isOpen = false;
			state.actions = [];
			state.position = {
				x: 0,
				y: 0
			};
			
		}
	}
});


export const { openContextMenu, closeContextMenu } = contextMenuSlice.actions;

export default contextMenuSlice.reducer;